import type { Verification } from 'dashboard/models/verification';

export enum VerificationStatus {
  Initiated = 'initiated',
  Confirmed = 'confirmed', // only for phone verification
  Submitted = 'submitted',
  Passed = 'passed',
  TentativelyPassed = 'tentatively_passed',
  TentativelyFailed = 'tentatively_failed',
  RequiresRetry = 'requires_retry',
  Failed = 'failed',
  Skipped = 'skipped', // only for AAMVA verifications
  Canceled = 'canceled',
}

const TERMINAL_STATUSES = new Set([
  VerificationStatus.Passed,
  VerificationStatus.RequiresRetry,
  VerificationStatus.Failed,
  VerificationStatus.Canceled,
  VerificationStatus.Skipped,
]);

export function isVerificationInTerminalState(verification?: Verification): boolean {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return TERMINAL_STATUSES.has(verification?.attributes.status);
}
